export enum HotelAvailable {
    None = 0,
    All = 1,
    ByRequest = 2,
}